import { useToast } from "@/hooks/use-toast"
import {
 Toast,
 ToastClose,
 ToastDescription,
 ToastProvider,
 ToastTitle,
 ToastViewport,
} from "@/components/ui/toast"
import { CheckCircle2, AlertCircle } from "lucide-react"

export function Toaster() {
 const { toasts } = useToast()

 return (
 <ToastProvider>
 {toasts.map(function ({ id, title, description, action, ...props }) {
 const isDestructive = props.variant === "destructive";
 return (
 <Toast key={id} {...props}>
 <div className="flex items-start gap-3">
 {isDestructive ? (
 <AlertCircle className="h-5 w-5 text-destructive-foreground shrink-0 mt-0.5" />
 ) : title ? (
 <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
 ) : null}
 <div className="grid gap-0.5">
 {title && <ToastTitle>{title}</ToastTitle>}
 {description && (
 <ToastDescription>{description}</ToastDescription>
 )}
 </div>
 </div>
 {action}
 <ToastClose />
 </Toast>
 )
 })}
 <ToastViewport />
 </ToastProvider>
 )
}
